import * as React from "react";
import ReactTooltip from "react-tooltip";
import { makeStyles } from "@material-ui/core";
import { classNames } from "@util/html.util";

// styles
import { colors } from "@styles/color.styles";

// material-ui
import { FormControl, FormControlLabel, Switch, withStyles } from "@material-ui/core";

export interface TooltipToggleProps {
  toggledOn: boolean;
  getTooltipText?: () => string | JSX.Element;
  onToggle: () => void;
  disabled?: boolean;
  style?: object;
  toolTipKey: string;
  loading: boolean;
  variant?: "peach";
  label?: string | JSX.Element;
  className?: string;
}

const useStyles = makeStyles({
  container: {},
});

const WarningSwitch = withStyles({
  switchBase: {
    "&$checked": {
      color: colors.peach.darker,
    },
    "&$checked + $track": {
      backgroundColor: colors.peach.darker,
    },
  },
  checked: {},
  track: {},
})(Switch);

const getSwitchComponent = (variant: string | undefined) => {
  switch (variant) {
    case "peach":
      return WarningSwitch;
    default:
      return Switch;
  }
};

export const TooltipToggle = ({
  toggledOn,
  onToggle,
  disabled,
  style,
  toolTipKey,
  getTooltipText,
  variant,
  loading,
  label,
  className,
}: TooltipToggleProps) => {
  const classes = useStyles();

  const toolTipId = "tooltip-" + toolTipKey;
  const tooltipText = loading ? "Loading..." : getTooltipText?.();

  const SwitchComponent = getSwitchComponent(variant);

  return (
    <div
      className={classNames([classes.container, className])}
      data-for={toolTipId}
      data-tip="" /* Needed to render empty tooltip */
      cw-id="tooltip-toggle"
    >
      <FormControl>
        <FormControlLabel
          style={{
            cursor: disabled ? "not-allowed" : "pointer",
            marginLeft: 0,
            ...style,
          }}
          control={
            <div
              style={{
                opacity: disabled ? 0.5 : 1,
              }}
            >
              <SwitchComponent
                aria-disabled={disabled}
                color="primary"
                checked={toggledOn}
                style={{
                  cursor: disabled ? "not-allowed" : "pointer",
                }}
              />
            </div>
          }
          onChange={() => (disabled ? null : onToggle())}
          label={label}
          labelPlacement="start"
        />
        {tooltipText && <ReactTooltip id={toolTipId}>{tooltipText}</ReactTooltip>}
      </FormControl>
    </div>
  );
};
